// import { ISession } from "models";
import React, {useEffect, useMemo, useState} from "react";

export interface ISession {
    isActive: boolean;
    isAuth: boolean;
    exp: undefined;
    payload: IPayload;
    token: string;
}

export interface IPayload {
    data: { user: { id: string | undefined } }
    exp: number | undefined,
    iat: number | undefined,
    iss: string | undefined,
    nbf: number | undefined
}

const context = {
    isActive: false,
    isAuth: false,
    exp: undefined,
    payload: {
        data: {user: {id: undefined}},
        exp: undefined,
        iat: undefined,
        iss: undefined,
        nbf: undefined
    },
    token: "",
};
const contextFunction = {
    createSession: (session: ISession): ISession => session,
    logOutUser: (): null => null,
}

export const SessionContext = React.createContext({...context, ...contextFunction});

export const SessionProvider: React.FC = ({children}) => {
    const name = "sbaj_session";
    const [session, setSession] = useState<ISession | null>(null);

    useEffect(() => {
        const contextSession = context;
        const sessionItem = localStorage.getItem(name);
        if (sessionItem) {
            const sessionParsed = JSON.parse(sessionItem);
            const isAuth = Date.now() < sessionParsed.exp * 1000;

            if (isAuth) {
                setSession((state: any) => ({...state, ...sessionParsed, isActive: true}));
            } else {
                localStorage.removeItem(name);
                setSession({...contextSession, isAuth: isAuth});
            }
        } else {
            setSession((state: any) => ({...state, ...contextSession, isActive: false}));
        }
    }, []);

    const createSession = (newSession: ISession) => {
        localStorage.setItem(name, JSON.stringify(newSession));
        setSession((state: any) => ({...state, ...newSession, active: true}));
        return newSession;
    };

    const logOutUser = () => {
        // call logout api
        // logoutUserMutation();
        localStorage.removeItem(name);
        window.location.href = "/";
    };

    const providerValue = useMemo(() => ({
        ...session,
        createSession,
        logOutUser,
    } as any), [session]);

    return (
        <SessionContext.Provider
            value={providerValue}
        >
            {session ? children : null}
        </SessionContext.Provider>
    );
};
